import React, { useState, useEffect } from 'react';

const COOKIE_KEY = 'famora_cookies_accepted';

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      zIndex: 9999,
      background: '#16162A',
      borderTop: '1px solid rgba(124,111,247,.3)',
      padding: '16px 24px',
      display: 'flex', alignItems: 'center', gap: 16,
      flexWrap: 'wrap',
      boxShadow: '0 -4px 24px rgba(0,0,0,.3)',
    }}>
      <span style={{ fontSize: 20, flexShrink: 0 }}>🍪</span>
      <div style={{ flex: 1, minWidth: 200, fontSize: 13, color: '#C0C0D8', lineHeight: 1.5 }}>
        Famora bruker informasjonskapsler (cookies) for å holde deg innlogget og huske innstillinger.
        Vi samler ikke inn persondata utover det som er nødvendig for at tjenesten skal fungere.
      </div>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={accept}
          style={{
            padding: '9px 20px', borderRadius: 9, border: 'none',
            background: '#7C6FF7', color: 'white', fontWeight: 700,
            fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          Aksepter
        </button>
        <a
          href="/personvern"
          style={{
            padding: '9px 14px', borderRadius: 9,
            border: '1px solid rgba(255,255,255,.15)',
            color: '#9090B8', fontSize: 12, cursor: 'pointer',
            fontFamily: 'inherit', textDecoration: 'none',
            display: 'flex', alignItems: 'center',
          }}
        >
          Les mer
        </a>
      </div>
    </div>
  );
}
